export default __webpack_public_path__ + "static/media/audio1.21d2eae2.gif";